module.exports = __webpack_public_path__ + "img/GF4sat.c560ad6c.png";